import { AccountsRole } from '@core/store/user/user.model';

export interface AdminAccessSubject {
  is_staff?: boolean;
  is_superuser?: boolean;
  is_limited?: boolean;
  accounts_role?: AccountsRole | null;
}

export type AdminAccessDecision =
  | { allow: true }
  | { allow: false; redirectTo: '/client' | '/admin/user-management' };

const allowed: AdminAccessDecision = { allow: true };
const clientRedirect: AdminAccessDecision = {
  allow: false,
  redirectTo: '/client',
};
const adminRedirect: AdminAccessDecision = {
  allow: false,
  redirectTo: '/admin/user-management',
};

function isInternalUser(user: AdminAccessSubject | null | undefined): boolean {
  return user?.is_staff === true && user.is_limited !== true;
}

/**
 * The role matrix for administrative routes and navigation.
 *
 * This policy is deliberately pure. Authentication and routing remain the
 * responsibility of its callers; they only adapt the returned decision.
 */
export const adminAccessPolicy = {
  enterAdmin(user: AdminAccessSubject | null | undefined): AdminAccessDecision {
    return isInternalUser(user) ? allowed : clientRedirect;
  },

  performStaffWork(user: AdminAccessSubject | null | undefined): AdminAccessDecision {
    return isInternalUser(user) ? allowed : clientRedirect;
  },

  manageForms(user: AdminAccessSubject | null | undefined): AdminAccessDecision {
    const mayManage =
      isInternalUser(user) &&
      (user?.is_superuser === true || user?.accounts_role === 'ops_manager');
    return mayManage ? allowed : adminRedirect;
  },

  managePlatform(user: AdminAccessSubject | null | undefined): AdminAccessDecision {
    return isInternalUser(user) && user?.is_superuser === true
      ? allowed
      : adminRedirect;
  },
};
